// extracted by mini-css-extract-plugin
export default {"container":"wuAtwjqweFC7xOQmCmRA"};